export const headerActionTypes = {
  newEntityButtonClick: '[APP Header] - new entity button click',
};
